const polizaGeneraCfdiLocks = new Set();

export function isPolizaGeneraCfdiInFlight(polizaId) {
    const id = Number(polizaId);
    return id > 0 && polizaGeneraCfdiLocks.has(id);
}

/**
 * Evita POST duplicados a CreateCfdi por la misma póliza (doble clic / bucles en paralelo).
 */
export async function generaCfdiPostWithLock(polizaId, requestFn) {
    const id = Number(polizaId);
    if (!id) {
        throw new Error('polizaId requerido');
    }
    if (polizaGeneraCfdiLocks.has(id)) {
        return { skipped: true, inFlight: true };
    }
    polizaGeneraCfdiLocks.add(id);
    try {
        return await requestFn();
    } finally {
        polizaGeneraCfdiLocks.delete(id);
    }
}
